
import React, { useEffect, useMemo, useState } from "react";

const API_BASE = "/api/cari";

const emptyForm = {
  full_name: "",
  phone: "",
  email: "",
  gender: "unknown",
  birth_date: "",
  city: "",
  address: "",
  note: "",
  tags: "",
  source_module: "manual",
  customer_type: "general",
  whatsapp_opt_in: true,
  aktif: true,
};

function getToken() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("accessToken") ||
    ""
  );
}

async function api(path, options = {}) {
  const token = getToken();

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  const text = await res.text();
  let data = {};

  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { ok: false, message: text };
  }

  if (!res.ok || data.ok === false) {
    throw new Error(data.message || "İşlem başarısız");
  }

  return data;
}

async function syncToBeautyPro(payload) {
  const token = getToken();

  const res = await fetch("/api/beaty/pro/customers", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      full_name: payload.full_name || "",
      phone: payload.phone || "",
      email: payload.email || "",
      birth_date: payload.birth_date || null,
      address: payload.address || "",
      city: payload.city || "",
      gender: payload.gender || "female",
      note: payload.note || "Cari modülünden oluşturuldu",
      aktif: payload.aktif !== false,
    }),
  });

  const json = await res.json().catch(() => ({}));

  if (!res.ok || json.ok === false) {
    console.warn("Beauty PRO eşitleme yapılamadı:", json.message || json);
    return false;
  }

  return true;
}


function genderLabel(value) {
  if (value === "female") return "Kadın";
  if (value === "male") return "Erkek";
  if (value === "other") return "Diğer";
  return "Belirtilmemiş";
}

function sourceLabel(value) {
  if (value === "beaty") return "Beauty";
  if (value === "appointment") return "Randevu";
  if (value === "qr") return "QR Menü";
  if (value === "kasa") return "Kasa";
  if (value === "message") return "Mesajlar";
  return "Manuel";
}

function typeLabel(value) {
  if (value === "vip") return "VIP";
  if (value === "debt") return "Borçlu";
  if (value === "campaign") return "Kampanya";
  if (value === "birthday") return "Doğum Günü";
  if (value === "session_finished") return "Seansı Dolan";
  if (value === "session_left") return "Seansı Kalan";
  return "Genel";
}




function dateLabel(value) {
  if (!value) return "-";
  const d = String(value).slice(0, 10);
  const p = d.split("-");
  if (p.length !== 3) return d;
  return `${p[2]}.${p[1]}.${p[0]}`;
}

function toNumber(value) {
  const n = Number(value || 0);
  return Number.isFinite(n) ? n : 0;
}

function firstNumber(...values) {
  for (const value of values) {
    if (
      value === undefined ||
      value === null ||
      value === ""
    ) {
      continue;
    }

    const number = Number(value);

    if (Number.isFinite(number)) {
      return number;
    }
  }

  return null;
}

function formatMoney(value, currency = "TRY") {
  const n = toNumber(value);

  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: currency || "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}

function getCustomerFinance(customer = {}) {
  const currency =
    customer.currency ||
    customer.para_birimi ||
    "TRY";

  const remainingDebt = firstNumber(
    customer.remaining_debt,
    customer.open_debt,
    customer.kalan_borc,
    customer.kalan_borc_tutari
  );

  const grossDebt = Math.max(
    toNumber(customer.debt_amount),
    toNumber(customer.total_debt),
    toNumber(customer.borc),
    toNumber(customer.borc_tutari),
    toNumber(customer.debit_total)
  );

  const grossReceivable = Math.max(
    toNumber(customer.receivable_amount),
    toNumber(customer.credit_amount),
    toNumber(customer.total_receivable),
    toNumber(customer.alacak),
    toNumber(customer.alacak_tutari),
    toNumber(customer.credit_total)
  );

  const rawBalance = firstNumber(
    customer.balance_amount,
    customer.net_balance,
    customer.bakiye
  );

  const calculatedBalance =
    grossDebt - grossReceivable;

  const netBalance =
    remainingDebt !== null
      ? remainingDebt
      : rawBalance !== null &&
          (
            rawBalance !== 0 ||
            (
              grossDebt === 0 &&
              grossReceivable === 0
            )
          )
        ? rawBalance
        : calculatedBalance;

  const debt = Math.max(netBalance, 0);
  const receivable = Math.max(
    -netBalance,
    0
  );

  let label = "Borcu Yok";
  let color = "#027A48";
  let bg = "#ECFDF3";

  if (netBalance > 0) {
    label = "Borçlu";
    color = "#B42318";
    bg = "#FEF3F2";
  } else if (netBalance < 0) {
    label = "Alacaklı";
    color = "#175CD3";
    bg = "#EFF8FF";
  }

  return {
    currency,
    debt,
    receivable,
    netBalance,
    label,
    color,
    bg,
  };
}

export default function CariPage() {
 const [customers, setCustomers] = useState([]);
const [summary, setSummary] = useState(null);

const [loading, setLoading] = useState(false);
const [saving, setSaving] = useState(false);
const [message, setMessage] = useState("");
const [editId, setEditId] = useState(null);
const [modalOpen, setModalOpen] = useState(false);
const [form, setForm] = useState(emptyForm);

const [viewFilter, setViewFilter] = useState("all");
const [detailOpen, setDetailOpen] = useState(false);
const [detailCustomer, setDetailCustomer] = useState(null);
const [detailAccount, setDetailAccount] = useState(null);
const [detailLoading, setDetailLoading] = useState(false);

  const [filters, setFilters] = useState({
    search: "",
    gender: "",
    source: "",
    status: "",
    sort: "name_asc",
  });

  const totals = useMemo(() => {
    return summary?.totals || {};
  }, [summary]);

const customerFinanceRows = useMemo(() => {
  return customers.map((customer) => {
    const finance = getCustomerFinance(customer);

    return {
      customer,
      finance,
      status:
        finance.netBalance > 0
          ? "debt"
          : finance.netBalance < 0
          ? "credit"
          : "clear",
    };
  });
}, [customers]);

const financialTotals = useMemo(() => {
  return customerFinanceRows.reduce(
    (acc, row) => {
      const { finance } = row;

      acc.totalDebt += finance.debt;
      acc.totalReceivable += finance.receivable;
      acc.netBalance += finance.netBalance;

      if (finance.netBalance > 0) acc.debtorCount += 1;
      if (finance.netBalance < 0) acc.creditorCount += 1;
      if (finance.netBalance === 0) acc.clearCount += 1;

      return acc;
    },
    {
      totalDebt: 0,
      totalReceivable: 0,
      netBalance: 0,
      debtorCount: 0,
      creditorCount: 0,
      clearCount: 0,
    }
  );
}, [customerFinanceRows]);

const visibleCustomers = useMemo(() => {
  if (viewFilter === "debt") {
    return customerFinanceRows
      .filter((row) => row.status === "debt")
      .map((row) => row.customer);
  }

  if (viewFilter === "clear") {
    return customerFinanceRows
      .filter((row) => row.status === "clear")
      .map((row) => row.customer);
  }

  if (viewFilter === "credit") {
    return customerFinanceRows
      .filter((row) => row.status === "credit")
      .map((row) => row.customer);
  }

  return customerFinanceRows.map((row) => row.customer);
}, [customerFinanceRows, viewFilter]);

const selectedCustomer = useMemo(() => {
  return customers.find((x) => x.id === editId) || null;
}, [customers, editId]);

  function show(text) {
    setMessage(text);
    setTimeout(() => setMessage(""), 3000);
  }

  function changeForm(name, value) {
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  function changeFilter(name, value) {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  async function hydrateCustomerFinances(rows = []) {
  const enrichedRows = [];
  const chunkSize = 20;

  for (let i = 0; i < rows.length; i += chunkSize) {
    const chunk = rows.slice(i, i + chunkSize);

    const enrichedChunk = await Promise.all(
      chunk.map(async (customer) => {
        try {
          const accountResult = await api(`/customers/${customer.id}/account`);
          const account = accountResult.data || {};
          const finance = account.finance || {};

          return {
            ...customer,

         debt_amount:
  finance.debt_amount ??
  finance.debt ??
  finance.total_debt ??
  customer.debt_amount ??
  customer.remaining_debt ??
  customer.total_debt ??
  0,

remaining_debt:
  finance.remaining_debt ??
  finance.open_debt ??
  finance.kalan_borc ??
  customer.remaining_debt ??
  customer.open_debt ??
  customer.kalan_borc ??
  undefined,

receivable_amount:
  finance.receivable_amount ??
  finance.receivable ??
  finance.total_receivable ??
  customer.receivable_amount ??
  customer.credit_amount ??
  customer.total_receivable ??
  0,

balance_amount:
  finance.balance_amount ??
  finance.net_balance ??
  finance.balance ??
  customer.balance_amount ??
  customer.net_balance ??
  customer.bakiye ??
  undefined,

currency:
  finance.currency ||
  customer.currency ||
  "TRY",
          };
        } catch {
          return customer;
        }
      })
    );

    enrichedRows.push(...enrichedChunk);
  }

  return enrichedRows;
}

async function loadCustomers() {
  setLoading(true);

  try {
    const q = new URLSearchParams();

    q.set("limit", "500");
    q.set("offset", "0");

    if (filters.search) q.set("search", filters.search);
    if (filters.gender) q.set("gender", filters.gender);
    if (filters.source) q.set("source", filters.source);
    if (filters.status) q.set("status", filters.status);
    if (filters.sort) q.set("sort", filters.sort);

    const result = await api(`/customers?${q.toString()}`);
    const rows = Array.isArray(result.data) ? result.data : [];

    const enrichedRows = await hydrateCustomerFinances(rows);

    setCustomers(enrichedRows);
  } catch (err) {
    show(err.message || "Cari listesi alınamadı");
  } finally {
    setLoading(false);
  }
}


async function loadSummary() {
  try {
    const result = await api("/reports/summary");
    setSummary(result.data || null);
  } catch {
    setSummary(null);
  }
}


  useEffect(() => {
    loadCustomers();
    loadSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function openNew() {
    setEditId(null);
    setForm(emptyForm);
    setModalOpen(true);
  }

  function openEdit(customer) {
    setEditId(customer.id);

    setForm({
      full_name: customer.full_name || "",
      phone: customer.phone || "",
      email: customer.email || "",
      gender: customer.gender || "unknown",
      birth_date: customer.birth_date ? String(customer.birth_date).slice(0, 10) : "",
      city: customer.city || "",
      address: customer.address || "",
      note: customer.note || "",
      tags: Array.isArray(customer.tags) ? customer.tags.join(", ") : "",
      source_module: customer.source_module || "manual",
      customer_type: customer.customer_type || "general",
      whatsapp_opt_in: customer.whatsapp_opt_in !== false,
      aktif: customer.aktif !== false,
    });

    setModalOpen(true);
  }

function closeModal() {
  setModalOpen(false);
  setEditId(null);
  setForm(emptyForm);
}

function closeDetail() {
  setDetailOpen(false);
  setDetailCustomer(null);
  setDetailAccount(null);
  setDetailLoading(false);
}

async function openCustomerDetail(customer) {
  setDetailCustomer(customer);
  setDetailAccount(null);
  setDetailOpen(true);
  setDetailLoading(true);

  try {
    const result = await api(`/customers/${customer.id}/account`);
    setDetailAccount(result.data || null);
  } catch (err) {
    setDetailAccount({
      customer,
      packages: [],
      payments: [],
      movements: [],
      finance: getCustomerFinance(customer),
    });

    show(err.message || "Cari detay alınamadı");
  } finally {
    setDetailLoading(false);
  }
}



async function saveCustomer(e) {
  e.preventDefault();

  if (!form.full_name.trim()) {
    show("Ad Soyad zorunlu");
    return;
  }

  if (!form.phone.trim() && !form.email.trim()) {
    show("Telefon veya e-posta zorunlu");
    return;
  }

  setSaving(true);

  try {
    const payload = {
      ...form,
      birth_date: form.birth_date || null,
    };

    if (editId) {
      await api(`/customers/${editId}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });

      await syncToBeautyPro(payload);

      show("Cari kayıt güncellendi ve Beauty müşteri listesi eşitlendi");
    } else {
      await api("/customers", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      await syncToBeautyPro(payload);

      show("Cari kayıt oluşturuldu ve Beauty müşteri listesine işlendi");
    }

    closeModal();
    await loadCustomers();
    await loadSummary();
  } catch (err) {
    show(err.message || "Kayıt işlemi başarısız");
  } finally {
    setSaving(false);
  }
}




async function deleteCustomer(customer) {
  const customerId = customer?.id;

  if (!customerId) {
    show("Silinecek cari ID bulunamadı");
    return;
  }

  const ok = window.confirm(
    `${customer.full_name || "Bu cari"} isimli cari kayıt silinsin mi?\n\nBu işlem cari listesinden kaldırır ve bağlı kasa hareketlerini de temizler.`
  );

  if (!ok) return;

  setLoading(true);

  try {
    console.log("Cari silme isteği gönderiliyor:", customerId);

    const result = await api(`/customers/${customerId}`, {
      method: "DELETE",
    });

    if (detailCustomer && String(detailCustomer.id) === String(customerId)) {
      closeDetail();
    }

    show(result.message || "Cari kayıt silindi");

    // Local silmek yerine backend’den gerçek listeyi tekrar çekiyoruz.
    await loadCustomers();
    await loadSummary();
  } catch (err) {
    console.error("Cari silme frontend hatası:", err);
    show(err.message || "Silme işlemi başarısız");
  } finally {
    setLoading(false);
  }
}


  async function importBeaty() {
    const ok = window.confirm("Beauty müşterileri cari havuzuna aktarılsın mı?");
    if (!ok) return;

    setLoading(true);

    try {
      const result = await api("/import-beaty", {
        method: "POST",
      });

      const d = result.data || {};

      show(
        `Aktarım tamamlandı. Yeni: ${d.inserted || 0}, Güncellenen: ${
          d.updated || 0
        }, Atlanan: ${d.skipped || 0}`
      );

      await loadCustomers();
      await loadSummary();
    } catch (err) {
      show(err.message || "Beauty aktarımı yapılamadı");
    } finally {
      setLoading(false);
    }
  }

  function exportCsv() {
    const rows = [
      [
        "Ad Soyad",
        "Telefon",
        "E-posta",
        "Cinsiyet",
        "Doğum Tarihi",
        "Şehir",
        "Kaynak",
        "Tip",
        "Borç",
        "Alacak",
        "Net Bakiye",
        "Bakiye Durumu",
        "Aktif",
        "Not",
      ],
      ...customers.map((c) => {
        const finance = getCustomerFinance(c);

        return [
          c.full_name || "",
          c.phone || "",
          c.email || "",
          genderLabel(c.gender),
          dateLabel(c.birth_date),
          c.city || "",
          sourceLabel(c.source_module),
          typeLabel(c.customer_type),
          finance.debt,
          finance.receivable,
          finance.netBalance,
          finance.label,
          c.aktif === false ? "Pasif" : "Aktif",
          c.note || "",
        ];
      }),
    ];

    const csv = rows
      .map((row) =>
        row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(";")
      )
      .join("\n");

    const blob = new Blob(["\uFEFF" + csv], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `cari_musteriler_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();

    URL.revokeObjectURL(url);
  }

  return (
<div className="cari-page" style={styles.page}>
<div className="cari-header" style={styles.header}>
        <div>
          <div style={styles.badge}>MesYat Dijital</div>
          <h1 style={styles.title}>Cari / Müşteri Yönetimi</h1>
          <p style={styles.desc}>
            Beauty, randevu, kasa, QR menü ve manuel müşterileri tek cari havuzunda yönetin.
          </p>
        </div>

<div className="cari-actions" style={styles.actions}>
          <button style={styles.lightBtn} onClick={() => { loadCustomers(); loadSummary(); }}>
            Yenile
          </button>
          <button style={styles.blueBtn} onClick={importBeaty}>
            Beauty’den Aktar
          </button>
          <button style={styles.greenBtn} onClick={exportCsv}>
            CSV Al
          </button>
          <button style={styles.orangeBtn} onClick={openNew}>
            Yeni Cari
          </button>
        </div>
      </div>

      {message && <div style={styles.message}>{message}</div>}

<div className="cari-stats" style={styles.stats}>
  <Stat title="Toplam Cari" value={totals.total || customers.length || 0} color="#1E3A8A" />
<Stat
  title="Toplam Kalan Borç"
  value={formatMoney(
    financialTotals.totalDebt
  )}
  color="#B42318"
/>

  <Stat title="Toplam Alacak" value={formatMoney(financialTotals.totalReceivable)} color="#175CD3" />
  <Stat title="Borçlu Cari" value={`${financialTotals.debtorCount} kişi`} color="#B42318" />
  <Stat title="Borcu Yok" value={`${financialTotals.clearCount} kişi`} color="#027A48" />
</div>

<div className="cari-filter-card" style={styles.filterCard}>
        <input
          style={styles.input}
          placeholder="Ad, telefon, e-posta veya şehir ara"
          value={filters.search}
          onChange={(e) => changeFilter("search", e.target.value)}
        />

        <select
          style={styles.input}
          value={filters.gender}
          onChange={(e) => changeFilter("gender", e.target.value)}
        >
          <option value="">Tüm Cinsiyetler</option>
          <option value="female">Kadın</option>
          <option value="male">Erkek</option>
          <option value="other">Diğer</option>
          <option value="unknown">Belirtilmemiş</option>
        </select>

        <select
          style={styles.input}
          value={filters.source}
          onChange={(e) => changeFilter("source", e.target.value)}
        >
          <option value="">Tüm Kaynaklar</option>
          <option value="manual">Manuel</option>
          <option value="beaty">Beauty</option>
          <option value="appointment">Randevu</option>
          <option value="qr">QR Menü</option>
          <option value="kasa">Kasa</option>
          <option value="message">Mesajlar</option>
        </select>

        <select
          style={styles.input}
          value={filters.status}
          onChange={(e) => changeFilter("status", e.target.value)}
        >
          <option value="">Tüm Durumlar</option>
          <option value="active">Aktif</option>
          <option value="passive">Pasif</option>
        </select>

        <select
          style={styles.input}
          value={filters.sort}
          onChange={(e) => changeFilter("sort", e.target.value)}
        >
          <option value="name_asc">A-Z</option>
          <option value="name_desc">Z-A</option>
          <option value="newest">En Yeni</option>
          <option value="oldest">En Eski</option>
          <option value="city">Şehir</option>
        </select>

        <button style={styles.blueBtn} onClick={loadCustomers}>
          Ara
        </button>
      </div>

<CariFinanceReports
  rows={customerFinanceRows}
  active={viewFilter}
  onChange={setViewFilter}
/>

<div className="cari-card" style={styles.card}>
        <div style={styles.cardTitle}>
          <strong>Müşteri Listesi</strong>
<span>{loading ? "Yükleniyor..." : `${customers.length} kayıt`}</span>
        </div>
<div className="cari-table-wrap" style={styles.tableWrap}>
<table className="cari-table" style={styles.table}>
            <thead>
                          <tr>
                <Th>Ad Soyad</Th>
                <Th>İletişim</Th>
                <Th>Cinsiyet</Th>
                <Th>Doğum Tarihi</Th>
                <Th>Şehir</Th>
                <Th>Kaynak</Th>
                <Th>Tip</Th>
                <Th align="right">Borç</Th>
                <Th align="right">Alacak</Th>
                <Th align="right">Net Bakiye</Th>
                <Th>Bakiye Durumu</Th>
                <Th>Durum</Th>
                <Th align="right">İşlem</Th>
              </tr>
            </thead>

            <tbody>
              {loading && (
                <tr>
<Td colSpan={13} center>Yükleniyor...</Td>
                </tr>
              )}



{!loading && visibleCustomers.length === 0 && (
  <tr>
    <Td colSpan={13} center>Bu filtreye uygun cari kayıt bulunamadı.</Td>
  </tr>
)}

                   {!loading && visibleCustomers.map((c) => {
  const finance = getCustomerFinance(c);

  return (
    <tr
      key={c.id}
      onClick={() => openCustomerDetail(c)}
      style={{ cursor: "pointer" }}
      title="Cari detay ve tahsilat geçmişini aç"
    >
                    <Td>
                      <strong>{c.full_name}</strong>
                      {Array.isArray(c.tags) && c.tags.length > 0 && (
                        <div style={styles.small}>{c.tags.join(", ")}</div>
                      )}
                    </Td>
                    <Td>
                      <div>{c.phone || "-"}</div>
                      <div style={styles.small}>{c.email || "-"}</div>
                    </Td>
                    <Td>{genderLabel(c.gender)}</Td>
                    <Td>{dateLabel(c.birth_date)}</Td>
                    <Td>{c.city || "-"}</Td>
                    <Td>
                      <Pill color="#1E3A8A" bg="#EEF4FF">
                        {sourceLabel(c.source_module)}
                      </Pill>
                    </Td>
                    <Td>
                      <Pill color="#C4320A" bg="#FFF4ED">
                        {typeLabel(c.customer_type)}
                      </Pill>
                    </Td>
                    <Td align="right">
                      <strong style={{ color: finance.debt > 0 ? "#B42318" : "#667085" }}>
                        {formatMoney(finance.debt, finance.currency)}
                      </strong>
                    </Td>
                    <Td align="right">
                      <strong style={{ color: finance.receivable > 0 ? "#175CD3" : "#667085" }}>
                        {formatMoney(finance.receivable, finance.currency)}
                      </strong>
                    </Td>
                    <Td align="right">
                      <strong style={{ color: finance.color }}>
                        {formatMoney(finance.netBalance, finance.currency)}
                      </strong>
                    </Td>
                    <Td>
                      <Pill color={finance.color} bg={finance.bg}>
                        {finance.label}
                      </Pill>
                    </Td>
                    <Td>
                      <Pill
                        color={c.aktif === false ? "#B42318" : "#027A48"}
                        bg={c.aktif === false ? "#FEF3F2" : "#ECFDF3"}
                      >
                        {c.aktif === false ? "Pasif" : "Aktif"}
                      </Pill>
                    </Td>
                <Td align="right">
  <div style={styles.actionWrap}>
    <button
      style={styles.smallBlueBtn}
      onClick={(e) => {
        e.stopPropagation();
        openEdit(c);
      }}
    >
      Düzenle
    </button>

    <button
      style={styles.smallRedBtn}
      onClick={(e) => {
        e.stopPropagation();
        deleteCustomer(c);
      }}
    >
      Sil
    </button>
  </div>
</Td>
                  </tr>
                );
              })}




            </tbody>
                </table>
        </div>

        <div className="cari-mobile-list">
          {loading && (
            <div className="cari-mobile-empty">Yükleniyor...</div>
          )}

      {!loading && visibleCustomers.length === 0 && (
  <div className="cari-mobile-empty">Bu filtreye uygun cari kayıt bulunamadı.</div>
)}


{!loading &&
  visibleCustomers.map((c) => {
    const finance = getCustomerFinance(c);

    return (
<div
  className="cari-mobile-customer-card"
  key={`mobile-${c.id}`}
  onClick={() => openCustomerDetail(c)}
>

        <div className="cari-mobile-card-head">
          <div>
            <strong>{c.full_name}</strong>
            <span>{c.phone || "-"}</span>
          </div>

          <Pill color={finance.color} bg={finance.bg}>
            {finance.label}
          </Pill>
        </div>

        <div className="cari-mobile-info-grid">



                  <div>
                    <small>E-posta</small>
                    <b>{c.email || "-"}</b>
                  </div>

                  <div>
                    <small>Cinsiyet</small>
                    <b>{genderLabel(c.gender)}</b>
                  </div>

                  <div>
                    <small>Doğum Tarihi</small>
                    <b>{dateLabel(c.birth_date)}</b>
                  </div>

                  <div>
                    <small>Şehir</small>
                    <b>{c.city || "-"}</b>
                  </div>

               <div>
  <small>Kaynak</small>
  <b>{sourceLabel(c.source_module)}</b>
</div>

<div>
  <small>Tip</small>
  <b>{typeLabel(c.customer_type)}</b>
</div>

<div>
  <small>Kalan Borç</small>
  <b
    style={{
      color:
        finance.debt > 0
          ? "#B42318"
          : "#172033",
    }}
  >
    {formatMoney(
      finance.debt,
      finance.currency
    )}
  </b>
</div>

                  <div>
                    <small>Alacak</small>
                    <b style={{ color: finance.receivable > 0 ? "#175CD3" : "#172033" }}>
                      {formatMoney(finance.receivable, finance.currency)}
                    </b>
                  </div>

                  <div>
                    <small>Net Bakiye</small>
                    <b style={{ color: finance.color }}>
                      {formatMoney(finance.netBalance, finance.currency)}
                    </b>
                  </div>

                  <div>
                    <small>Kayıt Durumu</small>
                    <b>{c.aktif === false ? "Pasif" : "Aktif"}</b>
                  </div>
                </div>

                {Array.isArray(c.tags) && c.tags.length > 0 && (
                  <div className="cari-mobile-tags">{c.tags.join(", ")}</div>
                )}

                <div className="cari-mobile-card-actions">
               <button
  style={styles.smallBlueBtn}
  onClick={(e) => {
    e.stopPropagation();
    openEdit(c);
  }}
>
  Düzenle
</button>

<button
  style={styles.smallRedBtn}
  onClick={(e) => {
    e.stopPropagation();
    deleteCustomer(c);
  }}
>
  Sil
</button>
                </div>
                         </div>
              );
            })}
        </div>
      </div>

      {summary && (
<div className="cari-report-grid" style={styles.reportGrid}>
          <Report title="Kaynak Dağılımı" rows={summary.source} />
          <Report title="Şehir Dağılımı" rows={summary.city} />
          <Report title="Cinsiyet Dağılımı" rows={summary.gender} labelFn={genderLabel} />
          <Report title="Müşteri Tipleri" rows={summary.customer_type} labelFn={typeLabel} />
        </div>
      )}

      {modalOpen && (
<div className="cari-modal-back" style={styles.modalBack}>
<div className="cari-modal" style={styles.modal}>
<div className="cari-modal-head" style={styles.modalHead}>
              <div>
                <div style={styles.badge}>{selectedCustomer ? "Cari Düzenle" : "Yeni Cari"}</div>
                <h2 style={{ margin: "8px 0 0", color: "#1E3A8A" }}>
                  {selectedCustomer ? selectedCustomer.full_name : "Müşteri Bilgileri"}
                </h2>
              </div>

              <button style={styles.closeBtn} onClick={closeModal}>
                ×
              </button>
            </div>
<form className="cari-form" onSubmit={saveCustomer} style={styles.form}>
  {selectedCustomer && (
    <CariAccountSummary customer={selectedCustomer} />
  )}

  <label style={styles.label}>
    Ad Soyad / Ünvan *
                <input
                  style={styles.input}
                  value={form.full_name}
                  onChange={(e) => changeForm("full_name", e.target.value)}
                />
              </label>

<div className="cari-two-col" style={styles.twoCol}>
                <label style={styles.label}>
                  Telefon
                  <input
                    style={styles.input}
                    value={form.phone}
                    onChange={(e) => changeForm("phone", e.target.value)}
                  />
                </label>

                <label style={styles.label}>
                  E-posta
                  <input
                    style={styles.input}
                    type="email"
                    value={form.email}
                    onChange={(e) => changeForm("email", e.target.value)}
                  />
                </label>
              </div>

<div className="cari-two-col" style={styles.twoCol}>
                <label style={styles.label}>
                  Cinsiyet
                  <select
                    style={styles.input}
                    value={form.gender}
                    onChange={(e) => changeForm("gender", e.target.value)}
                  >
                    <option value="unknown">Belirtilmemiş</option>
                    <option value="female">Kadın</option>
                    <option value="male">Erkek</option>
                    <option value="other">Diğer</option>
                  </select>
                </label>

                <label style={styles.label}>
                  Doğum Tarihi
                  <input
                    style={styles.input}
                    type="date"
                    value={form.birth_date || ""}
                    onChange={(e) => changeForm("birth_date", e.target.value)}
                  />
                </label>
              </div>

<div className="cari-two-col" style={styles.twoCol}>
                <label style={styles.label}>
                  Şehir
                  <input
                    style={styles.input}
                    value={form.city}
                    onChange={(e) => changeForm("city", e.target.value)}
                  />
                </label>

                <label style={styles.label}>
                  Kaynak
                  <select
                    style={styles.input}
                    value={form.source_module}
                    onChange={(e) => changeForm("source_module", e.target.value)}
                  >
                    <option value="manual">Manuel</option>
                    <option value="beaty">Beauty</option>
                    <option value="appointment">Randevu</option>
                    <option value="qr">QR Menü</option>
                    <option value="kasa">Kasa</option>
                    <option value="message">Mesajlar</option>
                  </select>
                </label>
              </div>

              <label style={styles.label}>
                Müşteri Tipi
                <select
                  style={styles.input}
                  value={form.customer_type}
                  onChange={(e) => changeForm("customer_type", e.target.value)}
                >
                  <option value="general">Genel</option>
                  <option value="vip">VIP</option>
                  <option value="debt">Borçlu</option>
                  <option value="campaign">Kampanya</option>
                  <option value="birthday">Doğum Günü</option>
                  <option value="session_finished">Seansı Dolan</option>
                  <option value="session_left">Seansı Kalan</option>
                </select>
              </label>

              <label style={styles.label}>
                Adres
                <input
                  style={styles.input}
                  value={form.address}
                  onChange={(e) => changeForm("address", e.target.value)}
                />
              </label>

              <label style={styles.label}>
                Etiketler
                <input
                  style={styles.input}
                  placeholder="VIP, Borçlu, Kampanya"
                  value={form.tags}
                  onChange={(e) => changeForm("tags", e.target.value)}
                />
              </label>

              <label style={styles.label}>
                Not
                <textarea
                  style={styles.input}
                  rows={3}
                  value={form.note}
                  onChange={(e) => changeForm("note", e.target.value)}
                />
              </label>

<div className="cari-checks" style={styles.checks}>
                <label>
                  <input
                    type="checkbox"
                    checked={form.whatsapp_opt_in}
                    onChange={(e) => changeForm("whatsapp_opt_in", e.target.checked)}
                  />{" "}
                  WhatsApp mesaj izni var
                </label>

                <label>
                  <input
                    type="checkbox"
                    checked={form.aktif}
                    onChange={(e) => changeForm("aktif", e.target.checked)}
                  />{" "}
                  Aktif kayıt
                </label>
              </div>

<div className="cari-modal-actions" style={styles.modalActions}>
                <button type="button" style={styles.lightBtn} onClick={closeModal}>
                  Vazgeç
                </button>

                <button type="submit" style={styles.orangeBtn} disabled={saving}>
                  {saving ? "Kaydediliyor..." : editId ? "Güncelle" : "Kaydet"}
                </button>
              </div>
            </form>
          </div>
        </div>
         )}

      {detailOpen && (
        <CariDetailModal
          customer={detailCustomer}
          account={detailAccount}
          loading={detailLoading}
          onClose={closeDetail}
          onEdit={(customer) => {
            closeDetail();
            openEdit(customer);
          }}
          onDelete={deleteCustomer}
        />
      )}
    </div>
  );
}

function CariFinanceReports({ rows, active, onChange }) {
  const debtRows = rows
    .filter((row) => row.status === "debt")
    .sort((a, b) => b.finance.debt - a.finance.debt);

  const clearRows = rows.filter((row) => row.status === "clear");

  const creditRows = rows
    .filter((row) => row.status === "credit")
    .sort((a, b) => Math.abs(b.finance.netBalance) - Math.abs(a.finance.netBalance));

  const buttons = [
    { key: "all", label: "Tüm Cariler", count: rows.length },
    { key: "debt", label: "Borçlu", count: debtRows.length },
    { key: "clear", label: "Borcu Yok", count: clearRows.length },
    { key: "credit", label: "Alacaklı", count: creditRows.length },
  ];

  return (
    <div style={styles.financeReportCard}>
      <div style={styles.financeReportHead}>
        <div>
          <strong>Cari Borç / Alacak Raporu</strong>
          <span>Borcu olan, borcu biten ve alacaklı müşterileri tek ekranda takip edin.</span>
        </div>

        <div style={styles.financeTabs}>
          {buttons.map((btn) => (
            <button
              key={btn.key}
              type="button"
              style={{
                ...styles.financeTabBtn,
                ...(active === btn.key ? styles.financeTabBtnActive : {}),
              }}
              onClick={() => onChange(btn.key)}
            >
              {btn.label} ({btn.count})
            </button>
          ))}
        </div>
      </div>

      <div style={styles.financeReportGrid}>
        <MiniFinanceList
          title="En Çok Borcu Olanlar"
          rows={debtRows.slice(0, 5)}
          empty="Borçlu cari yok."
        />

        <MiniFinanceList
          title="Borcu Kapananlar"
          rows={clearRows.slice(0, 5)}
          empty="Borcu kapanan cari yok."
        />

        <MiniFinanceList
          title="Alacaklı Cariler"
          rows={creditRows.slice(0, 5)}
          empty="Alacaklı cari yok."
        />
      </div>
    </div>
  );
}

function MiniFinanceList({ title, rows, empty }) {
  return (
    <div style={styles.miniFinanceBox}>
      <h3>{title}</h3>

      {rows.length === 0 && <p>{empty}</p>}

      {rows.map(({ customer, finance }) => (
        <div key={`${title}-${customer.id}`} style={styles.miniFinanceLine}>
          <span>{customer.full_name || "-"}</span>
          <strong style={{ color: finance.color }}>
            {formatMoney(finance.netBalance, finance.currency)}
          </strong>
        </div>
      ))}
    </div>
  );
}

function CariDetailModal({
  customer,
  account,
  loading,
  onClose,
  onEdit,
  onDelete,
}) {
  const accountCustomer = account?.customer || customer || {};
  const financeData = account?.finance || {};

const mergedCustomer = {
  ...accountCustomer,

  debt_amount:
    financeData.debt_amount ??
    accountCustomer.debt_amount,

  remaining_debt:
    financeData.remaining_debt ??
    financeData.open_debt ??
    financeData.kalan_borc ??
    accountCustomer.remaining_debt ??
    accountCustomer.open_debt ??
    accountCustomer.kalan_borc,

  receivable_amount:
    financeData.receivable_amount ??
    accountCustomer.receivable_amount,

  balance_amount:
    financeData.balance_amount ??
    accountCustomer.balance_amount,

  currency:
    financeData.currency ||
    accountCustomer.currency,
};

  const finance = getCustomerFinance(mergedCustomer);
  const movements = Array.isArray(account?.movements) ? account.movements : [];
  const packages = Array.isArray(account?.packages) ? account.packages : [];
  const payments = Array.isArray(account?.payments) ? account.payments : [];

  return (
    <div className="cari-modal-back" style={styles.modalBack}>
      <div className="cari-detail-modal" style={styles.detailModal}>
        <div style={styles.modalHead}>
          <div>
            <div style={styles.badge}>Cari Kart</div>
            <h2 style={{ margin: "8px 0 0", color: "#1E3A8A" }}>
              {accountCustomer.full_name || "-"}
            </h2>
            <p style={{ margin: "6px 0 0", color: "#667085", fontWeight: 700 }}>
              {accountCustomer.phone || "-"}{" "}
              {accountCustomer.email ? `• ${accountCustomer.email}` : ""}
            </p>
          </div>

          <button style={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        {loading ? (
          <div style={styles.detailLoading}>Cari detay yükleniyor...</div>
        ) : (
          <div style={styles.detailBody}>
            <div style={styles.accountSummary}>
              <div style={styles.accountSummaryHead}>
                <div>
                  <div style={styles.accountMiniTitle}>Hesap Özeti</div>
                  <h3 style={styles.accountName}>{finance.label}</h3>
                  <div style={styles.accountSub}>
                    Kaynak: {sourceLabel(accountCustomer.source_module)} • Tip:{" "}
                    {typeLabel(accountCustomer.customer_type)}
                  </div>
                </div>

                <Pill color={finance.color} bg={finance.bg}>
                  {finance.label}
                </Pill>
              </div>

              <div style={styles.accountGrid}>


              <div style={styles.accountBox}>
  <span>Kalan Borç</span>
  <strong
    style={{
      color:
        finance.debt > 0
          ? "#B42318"
          : "#027A48",
    }}
  >
    {formatMoney(
      finance.debt,
      finance.currency
    )}
  </strong>
</div>

 <div style={styles.accountBox}>
  <span>Toplam Alacak</span>
  <strong
    style={{
      color:
        finance.receivable > 0
          ? "#175CD3"
          : "#027A48",
    }}
  >
    {formatMoney(
      finance.receivable,
      finance.currency
    )}
  </strong>
</div>

                <div style={styles.accountBox}>
                  <span>Net Bakiye</span>
                  <strong style={{ color: finance.color }}>
                    {formatMoney(finance.netBalance, finance.currency)}
                  </strong>
                </div>
              </div>
            </div>

            <div style={styles.detailActions}>
              <button style={styles.blueBtn} onClick={() => onEdit(accountCustomer)}>
                Cari Bilgisini Düzenle
              </button>

              <button style={styles.smallRedBtn} onClick={() => onDelete(accountCustomer)}>
                Cariyi Sil
              </button>
            </div>

            <div style={styles.detailGrid}>
              <div style={styles.detailPanel}>
                <h3>Paket / Satış Geçmişi</h3>

                {packages.length === 0 && <p style={styles.emptyText}>Paket satışı yok.</p>}

                {packages.map((pkg) => (
                  <div key={`pkg-${pkg.id}`} style={styles.detailLine}>
                    <div>
                      <strong>{pkg.package_title || pkg.package_name || "Paket"}</strong>
                      <span>{dateLabel(pkg.sale_date || pkg.created_at)}</span>
                    </div>
                    <b>{formatMoney(pkg.sale_price || 0, pkg.currency || "TRY")}</b>
                  </div>
                ))}
              </div>

              <div style={styles.detailPanel}>
                <h3>Tahsilat Geçmişi</h3>

                {payments.length === 0 && <p style={styles.emptyText}>Tahsilat kaydı yok.</p>}

                {payments.map((pay) => (
                  <div key={`pay-${pay.id}`} style={styles.detailLine}>
                    <div>
                      <strong>{pay.payment_type || pay.type || "Tahsilat"}</strong>
                      <span>
                        {dateLabel(pay.payment_date || pay.created_at)}
                        {pay.note ? ` • ${pay.note}` : ""}
                      </span>
                    </div>
                    <b style={{ color: "#027A48" }}>
                      {formatMoney(pay.amount || 0, pay.currency || "TRY")}
                    </b>
                  </div>
                ))}
              </div>
            </div>

            <div style={styles.detailPanel}>
              <h3>Cari Hareketleri</h3>

              {movements.length === 0 && <p style={styles.emptyText}>Cari hareket yok.</p>}

              {movements.map((m, index) => (
                <div key={`movement-${index}`} style={styles.movementLine}>
                  <div>
                    <strong>{m.title}</strong>
                    <span>{dateLabel(m.date)} • {m.type}</span>
                  </div>

                  <b style={{ color: m.kind === "payment" ? "#027A48" : "#B42318" }}>
                    {m.kind === "payment" ? "+" : "-"}
                    {formatMoney(m.amount || 0, m.currency || "TRY")}
                  </b>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Stat({ title, value, color }) {  

return (
    <div style={styles.stat}>
      <span style={styles.statTitle}>{title}</span>
      <strong style={{ ...styles.statValue, color }}>{value}</strong>
    </div>
  );
}

function CariAccountSummary({ customer }) {
  const finance = getCustomerFinance(customer);

  return (
    <div style={styles.accountSummary}>
      <div style={styles.accountSummaryHead}>
        <div>
          <div style={styles.accountMiniTitle}>Cari Kart / Hesap Özeti</div>
          <h3 style={styles.accountName}>{customer.full_name || "-"}</h3>
          <div style={styles.accountSub}>
            {customer.phone || "-"} {customer.email ? `• ${customer.email}` : ""}
          </div>
        </div>

        <Pill color={finance.color} bg={finance.bg}>
          {finance.label}
        </Pill>
      </div>

      <div style={styles.accountGrid}>


<div style={styles.accountBox}>
  <span>Kalan Borç</span>
  <strong
    style={{
      color:
        finance.debt > 0
          ? "#B42318"
          : "#027A48",
    }}
  >
    {formatMoney(
      finance.debt,
      finance.currency
    )}
  </strong>
</div>

        <div style={styles.accountBox}>
          <span>Toplam Alacak</span>
          <strong style={{ color: finance.receivable > 0 ? "#175CD3" : "#027A48" }}>
            {formatMoney(finance.receivable, finance.currency)}
          </strong>
        </div>

        <div style={styles.accountBox}>
          <span>Net Bakiye</span>
          <strong style={{ color: finance.color }}>
            {formatMoney(finance.netBalance, finance.currency)}
          </strong>
        </div>
      </div>

      <div style={styles.accountDetailGrid}>
        <div>
          <small>Kaynak</small>
          <b>{sourceLabel(customer.source_module)}</b>
        </div>

        <div>
          <small>Müşteri Tipi</small>
          <b>{typeLabel(customer.customer_type)}</b>
        </div>

        <div>
          <small>Cinsiyet</small>
          <b>{genderLabel(customer.gender)}</b>
        </div>

        <div>
          <small>Doğum Tarihi</small>
          <b>{dateLabel(customer.birth_date)}</b>
        </div>

        <div>
          <small>Şehir</small>
          <b>{customer.city || "-"}</b>
        </div>

        <div>
          <small>Kayıt Durumu</small>
          <b>{customer.aktif === false ? "Pasif" : "Aktif"}</b>
        </div>
      </div>

      {customer.note && (
        <div style={styles.accountNote}>
          <small>Not</small>
          <p>{customer.note}</p>
        </div>
      )}
    </div>
  );
}

function Report({ title, rows, labelFn }) {
  const list = Array.isArray(rows) ? rows : [];

  return (
    <div style={styles.reportBox}>
      <h3 style={styles.reportTitle}>{title}</h3>

      {list.length === 0 && <div style={styles.small}>Veri yok</div>}

      {list.slice(0, 8).map((r) => (
        <div key={`${title}-${r.label}`} style={styles.reportLine}>
          <span>{labelFn ? labelFn(r.label) : r.label || "-"}</span>
          <strong>{r.value || 0}</strong>
        </div>
      ))}
    </div>
  );
}

function Th({ children, align }) {
  return <th style={{ ...styles.th, textAlign: align || "left" }}>{children}</th>;
}

function Td({ children, align, colSpan, center }) {
  return (
    <td
      colSpan={colSpan}
      style={{
        ...styles.td,
        textAlign: center ? "center" : align || "left",
      }}
    >
      {children}
    </td>
  );
}

function Pill({ children, color, bg }) {
  return (
    <span
      style={{
        display: "inline-flex",
        padding: "4px 9px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 800,
        color,
        background: bg,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </span>
  );
}

const styles = {
page: {
  minHeight: "100vh",
  width: "100%",
  maxWidth: "100%",
  overflowX: "hidden",
  background: "#F6F8FB",
  padding: 24,
  fontFamily: "Inter, system-ui, Arial, sans-serif",
  color: "#172033",
},
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 20,
    marginBottom: 18,
    flexWrap: "wrap",
  },
  badge: {
    display: "inline-flex",
    background: "rgba(255,127,42,.12)",
    color: "#D95F00",
    padding: "6px 10px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 900,
  },
  title: {
    margin: "10px 0 6px",
    color: "#1E3A8A",
    fontSize: 30,
  },
  desc: {
    margin: 0,
    color: "#667085",
  },
  actions: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },
  orangeBtn: {
    border: 0,
    borderRadius: 10,
    padding: "11px 15px",
    background: "#FF7F2A",
    color: "#fff",
    fontWeight: 800,
    cursor: "pointer",
  },
  blueBtn: {
    border: 0,
    borderRadius: 10,
    padding: "11px 15px",
    background: "#1E3A8A",
    color: "#fff",
    fontWeight: 800,
    cursor: "pointer",
  },
  greenBtn: {
    border: 0,
    borderRadius: 10,
    padding: "11px 15px",
    background: "#059669",
    color: "#fff",
    fontWeight: 800,
    cursor: "pointer",
  },
  lightBtn: {
    border: "1px solid #D9E1EF",
    borderRadius: 10,
    padding: "11px 15px",
    background: "#fff",
    color: "#1E3A8A",
    fontWeight: 800,
    cursor: "pointer",
  },
 smallBlueBtn: {
  border: 0,
  borderRadius: 8,
  padding: "8px 11px",
  background: "#1E3A8A",
  color: "#fff",
  fontWeight: 900,
  cursor: "pointer",
  whiteSpace: "nowrap",
},
smallRedBtn: {
  border: 0,
  borderRadius: 8,
  padding: "8px 11px",
  background: "#D92D20",
  color: "#fff",
  fontWeight: 900,
  cursor: "pointer",
  whiteSpace: "nowrap",
},
actionWrap: {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 7,
  whiteSpace: "nowrap",
},



  message: {
    background: "#FFF4ED",
    border: "1px solid #FEDF89",
    color: "#B54708",
    padding: 12,
    borderRadius: 12,
    marginBottom: 14,
    fontWeight: 800,
  },
  stats: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 14,
    marginBottom: 14,
  },
  stat: {
    background: "#fff",
    border: "1px solid #EDF1F7",
    borderRadius: 18,
    padding: 18,
    boxShadow: "0 10px 30px rgba(16,24,40,.06)",
  },
  statTitle: {
    display: "block",
    color: "#667085",
    fontSize: 13,
    fontWeight: 800,
  },
  statValue: {
    display: "block",
    marginTop: 8,
    fontSize: 30,
  },
  filterCard: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: 10,
    background: "#fff",
    border: "1px solid #EDF1F7",
    borderRadius: 18,
    padding: 16,
    boxShadow: "0 10px 30px rgba(16,24,40,.06)",
    marginBottom: 14,
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    border: "1px solid #D0D5DD",
    borderRadius: 10,
    padding: "10px 11px",
    fontSize: 14,
  },
card: {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  background: "#fff",
  border: "1px solid #EDF1F7",
  borderRadius: 18,
  boxShadow: "0 10px 30px rgba(16,24,40,.06)",
  overflow: "hidden",
},
  cardTitle: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 18px",
    borderBottom: "1px solid #EDF1F7",
    color: "#1E3A8A",
  },
 tableWrap: {
  width: "100%",
  maxWidth: "100%",
  overflowX: "auto",
  overflowY: "hidden",
  WebkitOverflowScrolling: "touch",
},

table: {
  width: "100%",
  borderCollapse: "collapse",
  minWidth: 1280,
},
  th: {
    background: "#F9FBFF",
    color: "#344054",
    fontSize: 13,
    fontWeight: 900,
    padding: "13px 14px",
    borderBottom: "1px solid #EDF1F7",
    whiteSpace: "nowrap",
  },
  td: {
    fontSize: 13,
    padding: "13px 14px",
    borderBottom: "1px solid #EDF1F7",
    verticalAlign: "middle",
  },
  small: {
    color: "#667085",
    fontSize: 12,
    marginTop: 4,
  },
  reportGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 14,
    marginTop: 14,
  },
  reportBox: {
    background: "#fff",
    border: "1px solid #EDF1F7",
    borderRadius: 18,
    padding: 16,
    boxShadow: "0 10px 30px rgba(16,24,40,.06)",
  },
  reportTitle: {
    margin: "0 0 12px",
    color: "#1E3A8A",
    fontSize: 15,
  },
reportLine: {
  display: "flex",
  justifyContent: "space-between",
  gap: 12,
  borderTop: "1px solid #EDF1F7",
  padding: "9px 0",
  fontSize: 13,
  minWidth: 0,
  maxWidth: "100%",
  overflow: "hidden",
},
  modalBack: {
    position: "fixed",
    inset: 0,
    background: "rgba(15,23,42,.54)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    zIndex: 2000,
  },
modal: {
  width: "min(1180px, calc(100vw - 32px))",
  maxHeight: "92vh",
  overflowY: "auto",
  background: "#fff",
  borderRadius: 22,
  boxShadow: "0 28px 80px rgba(15,23,42,.32)",
},
detailModal: {
  width: "min(1180px, calc(100vw - 32px))",
  maxHeight: "92vh",
  overflowY: "auto",
  background: "#fff",
  borderRadius: 22,
  boxShadow: "0 28px 80px rgba(15,23,42,.32)",
},
detailBody: {
  padding: 20,
  display: "flex",
  flexDirection: "column",
  gap: 14,
},
detailLoading: {
  padding: 30,
  textAlign: "center",
  color: "#667085",
  fontWeight: 900,
},
detailActions: {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  flexWrap: "wrap",
},
detailGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gap: 14,
},
detailPanel: {
  background: "#fff",
  border: "1px solid #EDF1F7",
  borderRadius: 18,
  padding: 16,
  boxShadow: "0 10px 28px rgba(16,24,40,.05)",
},
detailLine: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
  borderTop: "1px solid #EDF1F7",
  padding: "11px 0",
},
movementLine: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
  borderTop: "1px solid #EDF1F7",
  padding: "11px 0",
},
emptyText: {
  margin: 0,
  color: "#667085",
  fontWeight: 750,
},
financeReportCard: {
  background: "#fff",
  border: "1px solid #EDF1F7",
  borderRadius: 18,
  padding: 16,
  boxShadow: "0 10px 30px rgba(16,24,40,.06)",
  marginBottom: 14,
},
financeReportHead: {
  display: "flex",
  justifyContent: "space-between",
  gap: 14,
  flexWrap: "wrap",
  marginBottom: 14,
},
financeTabs: {
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
},
financeTabBtn: {
  border: "1px solid #D9E1EF",
  borderRadius: 999,
  background: "#fff",
  color: "#1E3A8A",
  padding: "8px 12px",
  fontWeight: 900,
  cursor: "pointer",
},
financeTabBtnActive: {
  background: "#1E3A8A",
  color: "#fff",
  borderColor: "#1E3A8A",
},
financeReportGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 12,
},
miniFinanceBox: {
  background: "#F9FBFF",
  border: "1px solid #EDF1F7",
  borderRadius: 14,
  padding: 12,
},
miniFinanceLine: {
  display: "flex",
  justifyContent: "space-between",
  gap: 10,
  borderTop: "1px solid #E5EAF3",
  padding: "8px 0",
  fontSize: 13,
  fontWeight: 800,
},
  modalHead: {
    display: "flex",
    justifyContent: "space-between",
    padding: "22px 24px",
    borderBottom: "1px solid #EDF1F7",
  },
  closeBtn: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    border: 0,
    background: "#F2F4F7",
    color: "#344054",
    fontSize: 26,
    cursor: "pointer",
  },
  form: {
    padding: "22px 24px 24px",
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },
  twoCol: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 14,
  },
  label: {
    display: "flex",
    flexDirection: "column",
    gap: 7,
    fontSize: 12,
    fontWeight: 850,
    color: "#344054",
  },
  checks: {
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
    fontWeight: 800,
    color: "#344054",
  },
modalActions: {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  marginTop: 10,
},
accountSummary: {
  border: "1px solid #D9E7FF",
  borderRadius: 18,
  padding: 16,
  background:
    "linear-gradient(135deg, rgba(30,58,138,.06), rgba(255,127,42,.08))",
  boxShadow: "0 12px 32px rgba(16,24,40,.07)",
},
accountSummaryHead: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 12,
  marginBottom: 14,
},
accountMiniTitle: {
  display: "inline-flex",
  padding: "5px 9px",
  borderRadius: 999,
  background: "#EEF4FF",
  color: "#1E3A8A",
  fontSize: 11,
  fontWeight: 900,
},
accountName: {
  margin: "8px 0 4px",
  color: "#1E3A8A",
  fontSize: 22,
  lineHeight: 1.2,
},
accountSub: {
  color: "#667085",
  fontSize: 13,
  fontWeight: 700,
  wordBreak: "break-word",
},
accountGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
  gap: 10,
  marginBottom: 12,
},
accountBox: {
  background: "#fff",
  border: "1px solid #EDF1F7",
  borderRadius: 14,
  padding: 12,
},
accountDetailGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
  gap: 10,
},
accountNote: {
  marginTop: 12,
  background: "#fff",
  border: "1px solid #EDF1F7",
  borderRadius: 14,
  padding: 12,
},
};

if (
  typeof document !== "undefined" &&
  !document.getElementById("cari-mobile-style")
) {
  const styleTag = document.createElement("style");

  styleTag.id = "cari-mobile-style";
  styleTag.innerHTML = `
    .cari-page,
    .cari-page * {
      box-sizing: border-box;
    }

    .cari-page {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow-x: hidden !important;
    }

  .cari-header,
.cari-actions,
.cari-stats,
.cari-filter-card,
.cari-card,
.cari-report-grid,
.cari-report-grid > *,
.cari-modal,
.cari-form {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

    .cari-table-wrap {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      -webkit-overflow-scrolling: touch !important;
    }

    .cari-card {
      overflow: hidden !important;
    }

.cari-mobile-list {
  display: none;
}

.cari-mobile-customer-card {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  background: #ffffff;
  border-top: 1px solid #EDF1F7;
  padding: 14px;
}

.cari-mobile-card-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.cari-mobile-card-head strong {
  display: block;
  font-size: 15px;
  color: #1E3A8A;
  word-break: break-word;
}

.cari-mobile-card-head span {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  color: #667085;
  word-break: break-word;
}

.cari-mobile-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 12px;
  min-width: 0;
}

.cari-mobile-info-grid div {
  min-width: 0;
  background: #F9FBFF;
  border: 1px solid #EDF1F7;
  border-radius: 12px;
  padding: 9px;
}

.cari-mobile-info-grid small {
  display: block;
  font-size: 11px;
  color: #667085;
  font-weight: 800;
}

.cari-mobile-info-grid b {
  display: block;
  margin-top: 3px;
  font-size: 12px;
  color: #172033;
  word-break: break-word;
}

.cari-form small {
  display: block;
  color: #667085;
  font-size: 11px;
  font-weight: 850;
}

.cari-form p {
  margin: 4px 0 0;
  color: #344054;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 650;
}
.cari-mobile-tags {
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #FFF4ED;
  color: #B54708;
  font-size: 12px;
  font-weight: 800;
  word-break: break-word;
}

.cari-mobile-card-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 12px;
}

.cari-mobile-card-actions button {
  width: 100%;
  margin: 0 !important;
}

.cari-mobile-empty {
  padding: 16px;
  text-align: center;
  color: #667085;
  font-weight: 800;
}


    @media (max-width: 900px) {
      .cari-page {
        padding: 10px !important;
      }

.cari-table-wrap {
  display: none !important;
}

.cari-mobile-list {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow: hidden !important;
}

      .cari-header {
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 12px !important;
      }

      .cari-header h1 {
        font-size: 23px !important;
        line-height: 1.2 !important;
      }

      .cari-header p {
        font-size: 13px !important;
        line-height: 1.45 !important;
      }

      .cari-actions {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 8px !important;
      }

      .cari-actions button {
        width: 100% !important;
        min-width: 0 !important;
        min-height: 42px !important;
        padding: 10px 8px !important;
        font-size: 12px !important;
      }

      .cari-stats {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 10px !important;
      }

      .cari-stats > div {
        min-width: 0 !important;
        padding: 13px !important;
        border-radius: 14px !important;
      }

      .cari-stats strong {
        font-size: 22px !important;
        word-break: break-word !important;
      }

      .cari-filter-card {
        display: grid !important;
        grid-template-columns: 1fr !important;
        gap: 10px !important;
        padding: 12px !important;
        border-radius: 14px !important;
      }


      .cari-filter-card input,
      .cari-filter-card select,
      .cari-filter-card button {
        width: 100% !important;
        min-width: 0 !important;
        min-height: 42px !important;
        font-size: 14px !important;
      }
.cari-report-grid {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 12px !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

.cari-report-grid > div {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow: hidden !important;
}

.cari-report-grid span,
.cari-report-grid strong {
  min-width: 0 !important;
  word-break: break-word !important;
}
      .cari-table {
        width: max-content !important;
        min-width: 760px !important;
      }

      .cari-table th,
      .cari-table td {
        padding: 10px 8px !important;
        font-size: 12px !important;
        white-space: nowrap !important;
      }

      .cari-table button {
        padding: 7px 8px !important;
        font-size: 11px !important;
      }

      .cari-report-grid {
        grid-template-columns: 1fr !important;
      }

      .cari-modal-back {
        align-items: flex-start !important;
        justify-content: center !important;
        padding: 10px !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
      }

      .cari-modal {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        max-height: none !important;
        border-radius: 16px !important;
        margin: 8px 0 20px !important;
      }

      .cari-modal-head {
        padding: 16px !important;
        gap: 10px !important;
      }

      .cari-modal-head h2 {
        font-size: 20px !important;
        line-height: 1.2 !important;
      }

      .cari-form {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        padding: 16px !important;
        gap: 12px !important;
      }

      .cari-two-col {
        grid-template-columns: 1fr !important;
        gap: 10px !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
      }

      .cari-form input,
      .cari-form select,
      .cari-form textarea {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        min-height: 42px !important;
        font-size: 14px !important;
      }

      .cari-checks {
        flex-direction: column !important;
        gap: 8px !important;
        font-size: 13px !important;
      }

      .cari-modal-actions {
        display: grid !important;
        grid-template-columns: 1fr 1fr !important;
        width: 100% !important;
        gap: 8px !important;
      }

      .cari-modal-actions button {
        width: 100% !important;
        min-width: 0 !important;
        min-height: 42px !important;
      }
    }

    @media (max-width: 480px) {
      .cari-page {
        padding: 8px !important;
      }
.cari-mobile-info-grid {
  grid-template-columns: 1fr !important;
}

.cari-mobile-card-actions {
  grid-template-columns: 1fr !important;
}
      .cari-actions {
        grid-template-columns: 1fr !important;
      }

      .cari-stats {
        grid-template-columns: 1fr !important;
      }

      .cari-table {
        min-width: 700px !important;
      }

      .cari-modal-actions {
        grid-template-columns: 1fr !important;
      }
    }
  `;

  document.head.appendChild(styleTag);
}